//BASIC ROUTES
export const GET_LIST = 'list';
export const CREATE = 'create';
export const GET_APPROVAL_LIST = 'approval';
export const PREVIEW = ':id';

//Auth URLS
export const AUTH_PREFIX = 'auth';
export const LOGIN = 'login';
export const RESET_PWD = 'reset-password';
export const SET_PWD = 'password/reset/confirm';
export const AUTH_CALLBACK = 'callback';

//DASHBORD ROUTES & PAGES
export const APP_PREFIX = 'dashboard';
export const DASHBOARD_PAGE = '';
export const AVAILABILITY_PAGE = 'availability';
export const SCHEDULING_PAGE = 'scheduling';
export const AUTO_SCHEDULE_PAGE = 'auto-schedule';
export const HISTORIC_ROUTES_PAGE = 'historic-routes';
export const ROUTE_KM_REPORT_PAGE = 'route-km-report';
export const SERVICE_REQUESTS_PAGE = 'service-requests';
// The lines-based authoring screen. A SECOND create page, alongside the single-recurrence
// one above, which stays exactly as it is.
export const SERVICE_REQUEST_ARRANGEMENT_PAGE = 'service-request-arrangement';
// Step 0 (the three-card chooser) and the composer, as separate URLs — so the browser's own
// Back button can return to step 0, and a bookmark or a reload lands somewhere real rather
// than on whatever the screen's local state last happened to be.
export const SERVICE_REQUEST_ARRANGEMENT_INITIAL = 'initial';
export const SERVICE_REQUEST_ARRANGEMENT_COMPOSE = 'compose';
export const SHIFTS_PAGE = 'shifts';
export const CLIENT_PAGE = 'clients';
export const DOCTOR_PAGE = 'doctors';
export const SERVICE_PAGE = 'services';
export const SERVICE_TYPE_PAGE = 'service-types';
export const SERVICE_PACKAGE_PAGE = 'service-packages';
export const CLIENT_CATEGORY_PAGE = 'client-categories';
export const INVENTORY_CATEGORY_PAGE = 'inventory-categories';
export const CAREGIVER_GROUP_PAGE = 'caregiver-groups';
export const VISITS_PAGE = 'visits';
export const VISITS_LIST = 'list';
export const EDIT_VISIT = ':id/edit';
export const VISIT_SUMMARIES_LIST = 'summaries';
export const FORCED_ASSIGNMENTS_LIST = 'forced-assignments';
// The office's queue of the instructions doctors send. Plural `doctor-instructions`
// rather than the singular `doctor` prefix below, which is the doctor's own area.
export const DOCTOR_INSTRUCTION_QUEUE_PAGE = 'doctor-instructions';
export const NOTIFICATIONS_PAGE = 'notifications';
export const VISITS_CALENDAR_PAGE = 'visits-calendar';
export const QUERY_FILTERS_TEST_PAGE = 'query-filters-test';
// ------
export const BILLING_OVERVIEW_PAGE = 'billing-overview';
export const CUSTOMER_PROFILE_PAGE = 'customer-profile';
export const BALANCES_PAGE = 'balances';
export const PAYMENTS_PAGE = 'payments';
export const CAREGIVER_CASH_PAGE = 'caregiver-cash';
export const INVENTORY_PAGE = 'inventory';

//PAYROLL ROUTES
export const PAYROLL_PAGE = 'payroll';
export const PAYROLL_LIST = 'list';
export const PAYROLL_RUN_DETAIL = ':id';

//PROFILE ROUTES
export const PROFILE_PREFIX = 'profile';
export const EDIT_PROFILE = 'record/:id';
export const EDIT_PROFILE_URL = 'profile/record';

//USERS ROUTES
export const USERS_PREFIX = 'users';
export const NEW_USER = 'create';
export const EDIT_USER = ':id/edit';
export const USERS_LIST = 'list';
export const USER_AUDIT_LOGS = 'audit-logs';
export const USER_AUDIT_TRAIL = 'audit-trail';
export const USERS_ONLINE = 'online';

//CAREGIVERS ROUTES
export const CAREGIVERS_PREFIX = 'caregivers';
export const NEW_CAREGIVER = 'create';
export const EDIT_CAREGIVER = ':id/edit';
export const CAREGIVERS_LIST = 'list';

//CLIENT ROUTES
export const CLIENTS_PREFIX = 'clients';
export const NEW_CLIENT = 'create';
export const EDIT_CLIENT = ':id/edit';
export const VIEW_CLIENT = ':id/card';
export const CLIENTS_LIST = 'list';

//DOCTOR ROUTES
export const DOCTOR_PREFIX = 'doctors';
export const NEW_DOCTOR = 'create';
export const EDIT_DOCTOR = ':id/edit';
export const DOCTOR_LIST = 'list';

//SERVICE ROUTES
export const SERVICE_PREFIX = 'services';
export const NEW_SERVICE = 'create';
export const EDIT_SERVICE = ':id/edit';
export const SERVICE_LIST = 'list';

//SERVICE TYPES ROUTES
export const SERVICE_TYPE_PREFIX = 'service-types';
export const SERVICE_TYPE_LIST = '';

//SERVICE PACKAGES ROUTES
export const SERVICE_PACKAGE_PREFIX = 'service-packages';
export const NEW_SERVICE_PACKAGE = 'create';
export const EDIT_SERVICE_PACKAGE = ':id/edit';
export const SERVICE_PACKAGE_LIST = 'list';

//CLIENT CATEGORIES ROUTES
export const CLIENT_CATEGORY_PREFIX = 'client-categories';
export const CLIENT_CATEGORY_LIST = '';

export const SERVICE_REQUESTS_MANAGEMENT_PAGE = 'service-requests-management';
export const SERVICE_REQUESTS_MANAGEMENT_PAGE_LIST = 'list';
// The lines-editing screen for one existing request — the counterpart of the
// authoring screen above, reached from the management list's row actions.
export const EDIT_SERVICE_REQUEST_ARRANGEMENT = ':id/edit';

//NOTIFICATIONS ROUTES
export const NOTIFICATIONS_PREFIX = 'notifications';
export const NOTIFICATIONS_LIST = 'list';
export const READ_NOTIFICATION = ':id';

// ── Doctor portal ─────────────────────────────────────────────────────────────
// Singular `doctor`, deliberately: `doctors` is the admin's directory of doctor
// records, and these are the signed-in doctor's own screens. Two different
// things that would otherwise share a prefix.
export const DOCTOR_PORTAL_PAGE = 'doctor';
export const DOCTOR_PORTAL_OVERVIEW = 'overview';
export const DOCTOR_PORTAL_PATIENTS = 'patients';
export const DOCTOR_PORTAL_VISITS = 'visits';
export const DOCTOR_PORTAL_MEASUREMENTS = 'measurements';
export const DOCTOR_PORTAL_PROFILE = 'profile';
// The patient card sits under the doctor's own patients, so the path itself says
// whose view it is — which is also what makes the request run as `doc`.
export const DOCTOR_PORTAL_PATIENT_CARD = 'patients/:id/card';
